module.exports = __webpack_public_path__ + "static/media/Test2.335acb42.bmp";